import React from 'react';

function Logo(props) {
  return (
    <img
      alt="HDI Seguros"
      src="/static/hdi_logo_white.png"
      style={{ maxHeight: 52, maxWidth: 200, marginLeft: 15 }}
      {...props}
    />
  );
}

export default Logo;
